import { shipmentStatuses, theme } from '@reveni-io/reveni-ui'

export const getStylesByStatus = () => {
  return {
    [shipmentStatuses.requested]: {
      backgroundColor: theme.legacy.palette.pink.tone100,
      colorTitle: theme.legacy.palette.pink.tone700,
      colorHour: theme.legacy.palette.grey.tone500,
    },
    [shipmentStatuses.packed]: {
      backgroundColor: theme.legacy.palette.pink.tone100,
      colorTitle: theme.legacy.palette.pink.tone700,
      colorHour: theme.legacy.palette.grey.tone500,
    },
    [shipmentStatuses.ready]: {
      backgroundColor: theme.legacy.palette.lilac.tone100,
      colorTitle: theme.legacy.palette.lilac.tone700,
      colorHour: theme.legacy.palette.grey.tone500,
    },
    [shipmentStatuses.shipped]: {
      backgroundColor: theme.legacy.palette.blue.tone100,
      colorTitle: theme.legacy.palette.blue.tone700,
      colorHour: theme.legacy.palette.grey.tone500,
    },
    [shipmentStatuses.out_for_delivery]: {
      backgroundColor: theme.legacy.palette.blue.tone100,
      colorTitle: theme.legacy.palette.blue.tone700,
      colorHour: theme.legacy.palette.grey.tone500,
    },
    [shipmentStatuses.delivered]: {
      backgroundColor: theme.legacy.palette.green.tone100,
      colorTitle: theme.legacy.palette.teal.tone700,
      colorHour: theme.legacy.palette.grey.tone500,
    },
  }
}
